import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Flex,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Spinner,
  Tag,
  IconButton,
  useToast,
  HStack,
  Icon,
  Wrap,
  WrapItem,
  Input,
  Select,
  InputGroup,
  InputLeftElement,
} from "@chakra-ui/react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  LuPencil,
  LuMegaphone,
  LuInfo,
  LuMessageCircle,
  LuMessageSquare,
  LuMail,
  LuBell,
  LuSmartphone,
  LuPhone,
  LuSearch,
  LuWallet,
  LuShield,
} from "react-icons/lu";
import Pagination from "react-js-pagination";

import Header from "../../components/Header";
import BoxWrapper from "../../components/BoxWrapper/BoxWrapper";
import TemplateManagerSstats from "./Stats/TemplateManagerSstats";
import { fetchWrapper } from "../../helpers";
import { toast } from "react-toastify";


const TemplateManager = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [syncloading, setSyncLoading] = useState(false);
  // const [activePage, setActivePage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [customerList, setCustomerList] = useState(null);



  const [messageTypes, setMessageTypes] = useState([]);
  const [whatsAppStatusList, setWhatsAppStatusList] = useState([]);

  const [searchParams, setSearchParams] = useSearchParams();

  const [searchQuery, setSearchQuery] = useState(searchParams.get("query") || "");
  const [selectedChannel, setSelectedChannel] = useState(searchParams.get("channel_id") || "");
  const [selectedCustomer, setSelectedCustomer] = useState(searchParams.get("customer_id") || "");
  const [selectedType, setSelectedType] = useState(searchParams.get("type_id") || "");
  const [selectedStatus, setSelectedStatus] = useState(searchParams.get("status_id") || "");
  const [selectedWhatsAppStatus, setSelectedWhatsAppStatus] = useState(searchParams.get("whatsapp_status_id") || "");
  const [activePage, setActivePage] = useState(Number(searchParams.get("page")) || 1);
  const toastUI = useToast();



  const navigate = useNavigate();

  // Fetch message types for filter dropdown
  const fetchMessageTypes = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/message-type/list`;
      const data = await fetchWrapper.get(url);
      setMessageTypes(data.data || []);
    } catch (error) {
      console.error("Error loading message types:", error);
    }
  };


  // Fetch message types for filter dropdown
  const fetchWhatsAppStatusList = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/whatsapp-status/list`;
      const data = await fetchWrapper.get(url);
      setWhatsAppStatusList(data.data || []);
    } catch (error) {
      console.error("Error loading message types:", error);
    }
  };

  const fetchTemplates = async (page = 1, filters = {}) => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: itemsPerPage.toString(),
      });

      if (filters.query?.trim()) params.append("query", filters.query.trim());
      if (filters.channel_id) params.append("channel_id", filters.channel_id);
      if (filters.type_id) params.append("message_type_id", filters.type_id);
      if (filters.status_id) params.append("status_id", filters.status_id);
      if (filters.customer_id) params.append("customer_id", filters.customer_id);
      if (filters.whatsapp_status_id) params.append("whatsapp_status_id", filters.whatsapp_status_id);

      const url = `${process.env.REACT_APP_API_URL}/template-message/list?${params.toString()}`;
      const data = await fetchWrapper.get(url);

      setTemplates(data.data || []);
      setTotalItems(data.pagination?.total || 0);
    } catch (error) {
      console.error("Error loading templates:", error);
      toastUI({
        title: "Error",
        description: "Failed to load templates",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const [stats, setStats] = useState(null);


  const updateSearchParams = (params) => {
    const newParams = new URLSearchParams();

    if (params.query) newParams.set("query", params.query);
    if (params.channel_id) newParams.set("channel_id", params.channel_id);
    if (params.customer_id) newParams.set("customer_id", params.customer_id);
    if (params.type_id) newParams.set("type_id", params.type_id);
    if (params.status_id) newParams.set("status_id", params.status_id);
    if (params.whatsapp_status_id) newParams.set("whatsapp_status_id", params.whatsapp_status_id);
    if (params.page) newParams.set("page", params.page);

    setSearchParams(newParams);
  };


  const LoadCustomers = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/customer/list`;
      const data = await fetchWrapper.get(url);
      setCustomerList(data.data || []);
    } catch (error) {
      console.error('Error loading customers:', error);
      toast.error('Failed to load customers');
    }
  };
  const handleSync = async () => {
    setSyncLoading(true);
    try {
      // Build query params from filters
      const params = new URLSearchParams();
  
      if (selectedCustomer) params.append("customer_id", selectedCustomer);
      if (searchQuery) params.append("query", searchQuery);
      if (selectedChannel) params.append("channel_id", selectedChannel);
      if (selectedType) params.append("type_id", selectedType);
      if (selectedStatus) params.append("status_id", selectedStatus);
      if (selectedWhatsAppStatus) params.append("whatsapp_status_id", selectedWhatsAppStatus);
      params.append("page", activePage || 1);
  
      const url = `${process.env.REACT_APP_API_URL}/template-message/get-quality?${params.toString()}`;
  
      const data = await fetchWrapper.get(url);
  
      if (data.success) {
        toast.success("Successfully Synced");
        fetchTemplates(activePage, {
          query: searchQuery,
          channel_id: selectedChannel,
          type_id: selectedType,
          status_id: selectedStatus,
          whatsapp_status_id: selectedWhatsAppStatus,
          customer_id: selectedCustomer
        });
      } else {
        toast.error(data.message || "Failed to sync templates");
      }
    } catch (error) {
      console.error("Error syncing templates:", error);
      toast.error("Something went wrong while syncing");
    } finally {
      setSyncLoading(false);
    }
  };
  
  const fetchStats = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/template-message/list-stat?customer_id=${selectedCustomer}`;
      const data = await fetchWrapper.get(url);
      console.log(data);
      setStats(data.data);
    } catch (error) {
      console.error("Error fetching stats:", error);
      toast({
        title: "Error",
        description: "Failed to load template stats",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // Handle filter changes
  const handleFilterChange = () => {
    const filters = {
      query: searchQuery,
      channel_id: selectedChannel,
      type_id: selectedType,
      status_id: selectedStatus,
      whatsapp_status_id: selectedWhatsAppStatus,
      customer_id: selectedCustomer,
      page: 1,
    };

    updateSearchParams(filters);
    setActivePage(1);
    fetchTemplates(1, filters);
    fetchStats();
  };
  // 🔹 Handle search input debounce
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      handleFilterChange();
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [searchQuery]);

  // 🔹 Handle dropdown changes
  useEffect(() => {
    handleFilterChange();
  }, [selectedChannel, selectedType, selectedStatus, selectedCustomer, selectedWhatsAppStatus]);


  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    const filters = {
      query: searchQuery,
      channel_id: selectedChannel,
      type_id: selectedType,
      status_id: selectedStatus,
      customer_id: selectedCustomer,
      whatsapp_status_id: selectedWhatsAppStatus,
      page: pageNumber,
    };
    updateSearchParams(filters);
    fetchTemplates(pageNumber, filters);
  };


  useEffect(() => {
    const filters = {
      query: searchParams.get("query") || "",
      channel_id: searchParams.get("channel_id") || "",
      type_id: searchParams.get("type_id") || "",
      status_id: searchParams.get("status_id") || "",
      customer_id: searchParams.get("customer_id") || "",
      whatsapp_status_id: searchParams.get("whatsapp_status_id") || "",
    };

    const page = Number(searchParams.get("page")) || 1;
    setActivePage(page);

    fetchMessageTypes();
    fetchWhatsAppStatusList();
    LoadCustomers();
    fetchTemplates(page, filters);
    fetchStats();
  }, [searchParams]);

  const messageTypeConfig = {
    OTP: { icon: LuShield, color: "red.500" },
    Transaction: { icon: LuWallet, color: "green.500" },
    Marketing: { icon: LuMegaphone, color: "orange.400" },
    Informational: { icon: LuInfo, color: "purple.500" },
  };

  function MessageTypeCell({ type }) {
    const { icon, color } = messageTypeConfig[type.name] || {
      icon: LuInfo,
      color: "gray.500",
    };

    return (
      <HStack>
        <Icon as={icon} boxSize={3} color={color} />
        <Text fontWeight="medium">
          {type.name}
        </Text>
      </HStack>
    );
  }

  const availableChannels = [
    {
      name: "Whatsapp",
      icon: LuMessageCircle,
      color: "green",
      description: "Rich messaging with media and buttons",
      id: 2
    },
    {
      name: "SMS",
      icon: LuMessageSquare,
      color: "blue",
      description: "Simple text messages",
      id: 1
    },
    {
      name: "E-Mail",
      icon: LuMail,
      color: "red",
      description: "HTML emails with rich content",
      id: 3
    },
    {
      name: "Push Notification",
      icon: LuBell,
      color: "orange",
      description: "Mobile app notifications",
      id: 6
    },
    {
      name: "In-App Notification",
      icon: LuSmartphone,
      color: "purple",
      description: "In-app messages and alerts",
      id: 5
    },
    {
      name: "Voice (IVR)",
      icon: LuPhone,
      color: "teal",
      description: "Automated voice calls",
      id: 4
    }
  ];

  function SelectedChannels({ selectedChannels }) {
    const filteredChannels = availableChannels.filter(channel =>
      selectedChannels?.includes(channel.name)
    );

    return (
      <Wrap spacing={4}>
        {filteredChannels.map(channel => (
          <WrapItem key={channel.id}>
            <HStack spacing={1}>
              <Icon as={channel.icon} boxSize={3} color={`${channel.color}.500`} />
            </HStack>
          </WrapItem>
        ))}
      </Wrap>
    );
  }

  return (
    <>
      <Header />

      <BoxWrapper>
        <Flex justify="space-between" align="center" mb={6}>
          <Box>
            <Text fontSize="2xl" fontWeight="bold">
              Template Manager
            </Text>
            <Text fontSize="sm" color="gray.600">
              Create and manage notification templates across all channels
            </Text>
          </Box>
          <div>
            <Button
              colorScheme="blue"
              // borderRadius="sm"
              style={{ marginRight: "1rem" }}
              size={"sm"}
              onClick={handleSync}
              isDisabled={selectedCustomer == ""}
              isLoading={syncloading}
            >

              Sync
            </Button>
            <Button
              colorScheme="blue"
              // borderRadius="sm"
              onClick={() => navigate("/template-add")}
              size={"sm"}
            >
              + Create Template
            </Button>
          </div>
        </Flex>

        <TemplateManagerSstats stats={stats} />


        <Box className="box-style-card" mb={5} p={4}>
          <Flex gap={4} align="end" wrap="wrap">
            {/* Search Input */}
            <Box flex="1" minW="200px">
              <Text fontSize="sm" fontWeight="medium" mb={2} color="gray.700">
                Search Templates
              </Text>
              <InputGroup>
                <InputLeftElement pointerEvents="none">
                  <Icon as={LuSearch} color="gray.400" boxSize={4} />
                </InputLeftElement>
                <Input
                  placeholder="Search templates..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  bg="white"
                  size="sm"
                />
              </InputGroup>
            </Box>

            {/* Channel Filter */}
            <Box minW="150px">
              <Text fontSize="sm" fontWeight="medium" mb={2} color="gray.700">
                ALL Customer
              </Text>
              <Select
                value={selectedCustomer}
                onChange={(e) => setSelectedCustomer(e.target.value)}
                bg="white"
                size="sm"
              >
                <option value="">All Customer</option>
                {customerList?.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.business_name}
                  </option>
                ))}
              </Select>
            </Box>
            <Box minW="150px">
              <Text fontSize="sm" fontWeight="medium" mb={2} color="gray.700">
                All Channels
              </Text>
              <Select
                value={selectedChannel}
                onChange={(e) => setSelectedChannel(e.target.value)}
                bg="white"
                size="sm"
              >
                <option value="">All Channels</option>
                {availableChannels.map((channel) => (
                  <option key={channel.id} value={channel.id}>
                    {channel.name}
                  </option>
                ))}
              </Select>
            </Box>

            {/* Type Filter */}
            <Box minW="150px">
              <Text fontSize="sm" fontWeight="medium" mb={2} color="gray.700">
                All Types
              </Text>
              <Select
                value={selectedType}
                onChange={(e) => setSelectedType(e.target.value)}
                bg="white"
                size="sm"
              >
                <option value="">All Types</option>
                {messageTypes.map((type) => (
                  <option key={type.id} value={type.id}>
                    {type.name}
                  </option>
                ))}
              </Select>
            </Box>

            {/* Status Filter */}
            <Box minW="150px">
              <Text fontSize="sm" fontWeight="medium" mb={2} color="gray.700">
                All Status
              </Text>
              <Select
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
                bg="white"
                size="sm"
              >
                <option value="">All Status</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </Select>
            </Box>


            <Box minW="150px">
              <Text fontSize="sm" fontWeight="medium" mb={2} color="gray.700">
                Whatsapp Status
              </Text>
              <Select
                value={selectedWhatsAppStatus}
                onChange={(e) => setSelectedWhatsAppStatus(e.target.value)}
                bg="white"
                size="sm"
              >
                <option value="">All Status</option>
                {whatsAppStatusList.map((waRs) => (
                  <option key={waRs.id} value={waRs.id}>
                    {waRs.name}
                  </option>
                ))}


              </Select>
            </Box>
          </Flex>

          {/* Active Filters Display */}
          {(searchQuery || selectedChannel || selectedType || selectedStatus || selectedWhatsAppStatus) && (
            <Flex mt={3} gap={2} align="center" wrap="wrap">
              <Text fontSize="xs" color="gray.600">Active filters:</Text>
              {searchQuery && (
                <Tag size="sm" colorScheme="blue">
                  Search: {searchQuery}
                </Tag>
              )}
              {selectedChannel && (
                <Tag size="sm" colorScheme="green">
                  Channel: {availableChannels.find(c => c.id.toString() === selectedChannel)?.name}
                </Tag>
              )}
              {selectedType && (
                <Tag size="sm" colorScheme="purple">
                  Type: {messageTypes.find(t => t.id.toString() === selectedType)?.name}
                </Tag>
              )}
              {selectedStatus && (
                <Tag size="sm" colorScheme="orange">
                  Status: {selectedStatus === "1" ? "Active" : "Inactive"}
                </Tag>
              )}

              {selectedWhatsAppStatus && (
                <Tag size="sm" colorScheme="orange">
                  Whatsapp Status: {whatsAppStatusList.find(t => t.id.toString() === selectedWhatsAppStatus)?.name}
                </Tag>
              )}
              <Button
                size="xs"
                variant="ghost"
                colorScheme="gray"
                onClick={() => {
                  setSearchQuery("");
                  setSelectedChannel("");
                  setSelectedType("");
                  setSelectedStatus("");
                  setSelectedWhatsAppStatus("")
                }}
              >
                Clear all
              </Button>
            </Flex>
          )}
        </Box>


        {loading ? (
          <Flex justify="center" align="center" minH="200px">
            <Spinner size="xl" />
          </Flex>
        ) : (
          <>
            <Table
              variant="simple"
              borderWidth="1px"
              borderColor="gray.200"
              size="sm"
            >
              <Thead bg="gray.100">
                <Tr>
                  <Th textAlign="start" fontSize="sm">Name</Th>
                  <Th textAlign="start" fontSize="sm">Type</Th>
                  <Th textAlign="start" fontSize="sm">Channel</Th>
                  <Th textAlign="start" fontSize="sm">Status</Th>
                  {/* <Th textAlign="start" fontSize="sm">Usage</Th> */}
                  <Th textAlign="start" fontSize="sm">Created</Th>
                  <Th textAlign="start" fontSize="sm">Actions</Th>
                </Tr>
              </Thead>

              <Tbody>
                {templates.length > 0 ? (
                  templates.map((template) => {
                    const msgCombine = template.message_combine
                      ? JSON.parse(template.message_combine)
                      : {};

                    return (
                      <Tr key={template.id}>
                        <Td textAlign="start" fontSize="sm">
                          <Text fontWeight="normal" fontSize="sm">
                            {template.name}
                          </Text>
                          <Text fontSize="xs" color="gray.500">
                            {msgCombine?.description || "-"}
                          </Text>
                          {template?.WhatsAppStatus && (
                            <Tag
                              colorScheme={template?.WhatsAppStatus.color}
                              size="sm"
                            >
                              {template?.WhatsAppStatus.name}
                            </Tag>
                          )}
                        </Td>

                        <Td textAlign="start" fontSize="sm">
                          {MessageTypeCell({ type: template.MessageType })}
                        </Td>

                        <Td textAlign="start" fontSize="sm">
                          <SelectedChannels selectedChannels={msgCombine?.selectedChannels} />
                        </Td>

                        <Td textAlign="start" fontSize="sm">
                          <Tag colorScheme="green" size="sm">
                            {template.status_id === 1 ? "Active" : "Inactive"}
                          </Tag>
                        </Td>

                        {/* <Td textAlign="start" fontSize="sm">
                          {template?.useage}
                        </Td> */}
                        <Td textAlign="start" fontSize="sm">
                          {new Date(template.createdAt).toLocaleDateString()}
                        </Td>

                        <Td textAlign="start" fontSize="sm">
                          <Flex gap={2} alignItems="center">
                            <IconButton
                              aria-label="Edit Template"
                              icon={<LuPencil />}
                              size="sm"
                              variant="ghost"
                              onClick={() => navigate(`/template-edit/${template.id}`)}
                            />
                          </Flex>
                        </Td>
                      </Tr>
                    );
                  })
                ) : (
                  <Tr>
                    <Td colSpan={7} textAlign="center" fontSize="sm" color="gray.500">
                      No templates found
                    </Td>
                  </Tr>
                )}
              </Tbody>
            </Table>

            {/* Pagination */}
            {totalItems > itemsPerPage && (
              <Flex justify="center" mt={4}>
                <Pagination
                  activePage={activePage}
                  itemsCountPerPage={itemsPerPage}
                  totalItemsCount={totalItems}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                  itemClass="page-item"
                  linkClass="page-link"
                />
              </Flex>
            )}
          </>
        )}
      </BoxWrapper>
    </>
  );
};

export default TemplateManager;